import _ from "lodash";

function RegionSelector(props) {
  if ((props.regions || []).length <= 1) {
    return null;
  }

  return (
    <div className="RegionSelector">
      {props.showNational && (
        <div className="tabs is-toggle">
          <ul>
            <li
              onClick={() => props.onSelect("NATIONAL")}
              className={`${props.selected === "NATIONAL" ? "is-active" : ""}`}
            >
              <a>
                <span>Canada</span>
              </a>
            </li>
          </ul>
        </div>
      )}
      <div className="tabs is-toggle">
        <ul>
          {_.chain(props.regions)
            .filter((region) => region.name !== "NATIONAL")
            .sortBy("name")
            .value()
            .map((region) => (
              <li
                className={`${props.selected === region.name ? "is-active" : ""}`}
                key={region.name}
                onClick={() => props.onSelect(region.name)}
              >
                <a>
                  <span>{region.name}</span>
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default RegionSelector;
